import { gql } from '@biletiniz/apollo';

export const UPDATE_PROFILE = gql`
  mutation updateProfile($name: String!, $surname: String!) {
    updateProfile(name: $name, surname: $surname) {
      message
      status
    }
  }
`;
